import { useContext } from "react";
import { UserAuthenticationContext } from "../Context/UserAuthenticationContext";
import {withAffiliateReferral} from "../Helpers/AffiliateReferral";

export default function useFrontPageCta(guestText: string, guestLink: string) {
    const { doesAuthTokenExist } = useContext(UserAuthenticationContext);
    const isAuthenticated = doesAuthTokenExist?.() ?? false;

    return {
        text: isAuthenticated ? "Start Watching" : guestText,
        link: isAuthenticated ? "/browse" : withAffiliateReferral(guestLink),
    };
}
